/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <section class="my-single-order-page with-loader-absolute">
    <div class="account-content" v-if="currentOrder">
      <div class="account-content__header">
        <b-row no-gutters>
          <b-col cols="7" class="d-flex align-items-cente">
            <router-link :to="{ name: 'myOrders'}" class="btn btn-icon btn-icon-no-border">
              <svg class="o-icon"><use xlink:href="#back"></use></svg>
              <h4 class="text ml-3 my-0">{{ $t('route.my-single-order') }} N°{{ currentOrder.increment_id }}</h4>
            </router-link>
          </b-col>
          <!-- <b-col cols="5" v-if="!thankyoupageMode" class="d-flex align-items-center justify-content-end"> -->
            <!-- <router-link type="button" class="btn btn-icon btn-icon-small btn-icon-border-black btn-rounded" :to="{name: 'newReturns', query: { orderId: currentOrder.entity_id }}" v-if="showRefound">
              <svg class="o-icon fill-black"><use xlink:href="#return-order"></use></svg>
            </router-link> -->
            <!-- <button type="button" class="btn btn-primary btn-primary-small btn-primary-black btn-rounded ml-4" @click="reorder" :disabled="!isReordable">{{ $t('reorder') }}</button> -->
          <!-- </b-col> -->
        </b-row>
      </div>
      <div class="account-content__body">
        <div class="left-block">
          <div role="tablist" class="bcm-accordion accordion-order">
            <b-card no-body>
              <b-card-header header-tag="header" role="tab">
                <button v-b-toggle="'accordion-detail'" class="btn btn-none accordion-title d-flex align-items-center justify-content-between">
                  <div class="title">{{ $t('order.order-detail') }}</div>
                  <svg class="o-icon"><use xlink:href="#arrow-down"></use></svg>
                </button>
              </b-card-header>
              <b-collapse :id="'accordion-detail'" accordion="order-details" role="tabpanel">
                <b-card-body>
                  <order-detail :order="currentOrder" />
                </b-card-body>
              </b-collapse>
            </b-card>
            <b-card no-body>
              <b-card-header header-tag="header" role="tab">
                <button v-b-toggle="'accordion-items'" class="btn btn-none accordion-title d-flex align-items-center justify-content-between">
                  <div class="title">{{ $t('order.order-items') }}</div>
                  <div class="d-flex align-items-center">
                    <span class="items-count t-normal mr-3">
                      <!-- <span>{{ $tc('{count}-items', orderProduct.length, { count: orderProduct.length }) }}</span> -->
                    </span>
                    <svg class="o-icon"><use xlink:href="#arrow-down"></use></svg>
                  </div>
                </button>
              </b-card-header>
              <b-collapse :id="'accordion-items'" accordion="order-items" role="tabpanel">
                <b-card-body>
                  <!-- create table -->
                  <div class="bcm-table">
                    <div class="table-content">
                      <div class="table-item">
                        <template v-for="product in orderProduct">
                          <div :key="product.sku" class="wrapp-order-tile">
                            <order-item-tile :item="product" />
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
            <b-card no-body>
              <b-card-header header-tag="header" role="tab">
                <button v-b-toggle="'accordion-customer'" class="btn btn-none accordion-title d-flex align-items-center justify-content-between">
                  <div class="title">{{ $t('order.customer') }}</div>
                  <svg class="o-icon"><use xlink:href="#arrow-down"></use></svg>
                </button>
              </b-card-header>
              <b-collapse :id="'accordion-customer'" accordion="order-customer" role="tabpanel">
                <b-card-body>
                  <order-customer-detail :order="currentOrder" />
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>
        <div class="right-block">
          <div class="right-block-block">
            <div class="wrapp-title">
              <h1 class="title">{{ $t('order-summary') }}</h1>
            </div>
            <order-summary :order="currentOrder" :shippingInformation="shippingInformation"></order-summary>
          </div>
        </div>
      </div>
      <!-- <div class="account-content__footer">
        <router-link type="button" class="btn btn-secondary btn-secondary-small btn-secondary-with-icon btn-secondary-black btn-rounded" :to="{name: 'home' }">
          <span class="text">{{ $t('assistance-request') }}</span>
          <svg class="o-icon"><use xlink:href="#customer-service"></use></svg>
        </router-link>
      </div> -->
    </div>
    <absolute-loader :showLoader="showLoader" mode="fixed"></absolute-loader>
  </section>
</template>

<script>
import { EventBus } from '@/helpers'
import { toast } from 'theme/modules/notifications'
import OrderSummary from 'theme/components/MyAccount/Orders/Summary'
import TableLayout from 'theme/components/Tables/TableLayout'
import OrderItemTile from 'theme/components/Tables/Tiles/OrderItemTile'
import OrderDetail from 'theme/components/MyAccount/Orders/OrderDetail'
import OrderCustomerDetail from 'theme/components/MyAccount/Orders/OrderCustomerDetail'
import AbsoluteLoader from 'theme/components/AbsoluteLoader/AbsoluteLoader'
import Logger from '@/services/Logger'

export default {
  name: 'MySingleOrder',
  props: {
    orderId: {
      type: String
    },
    styleMode: {
      type: String
    }
  },
  data () {
    return {
      showLoader: false,
      shipmentCount: 0,
      shippedProducts: [],
      shippingInformation: [],
      tableTileComponent: OrderItemTile
    }
  },
  computed: {
    currentOrder () {
      if (Object.keys(this.$store.state.orders.currentOrder).length > 0) {
        EventBus.$emit('myAccount:updateTitle', { id: this.$store.state.orders.currentOrder.increment_id })
        return this.$store.state.orders.currentOrder
      } else {
        return null
      }
    },
    orderProduct () {
      return this.$store.getters['orders/getProduct']
    },
    thankyoupageMode () {
      return this.styleMode === 'thankyou'
    },
    showRefound () {
      return this.currentOrder.status === 'complete'
    },
    isReordable () {
      return this.currentOrder.extension_attributes && this.currentOrder.extension_attributes.is_reordered === true
    }
  },
  methods: {
    reorder () {
      const _this = this
      this.$store.commit('ui/showLoader')
      this.$store.dispatch('user/reorder', { id: this.currentOrder.entity_id })
        .then(() => {
          _this.$router.push({
            name: 'cart'
          })
        })
        .catch(err => {
          toast.error(_this.$t('GenericError'))
          Logger.error(err)
        })
        .finally(() => {
          _this.$store.commit('ui/hideLoader')
        })
    }
  },
  async mounted () {
    const _this = this
    const orderId = this.orderId || this.$route.params.id
    this.showLoader = true
    await this.$store.dispatch('orders/getOrderById', { orderId: orderId }).finally(() => {
      _this.showLoader = false
    })
  },
  components: {
    TableLayout,
    AbsoluteLoader,
    OrderSummary,
    OrderDetail,
    OrderCustomerDetail,
    OrderItemTile
  }
}
</script>
